import { applyConfigurationModelSimple, interpretConfigurationModelSimple } from "@dataspecer/core-v2/configuration-model";
import { getDefaultUserGivenAlgorithmConfigurationsFull } from "./configurations/user-algorithm-configurations.js";
export function createLayoutConfiguration(configuration) {
    return interpretConfigurationModelSimple(configuration, LAYOUT_ALGORITHM_CONFIGURATION_IRI, getDefaultUserGivenAlgorithmConfigurationsFull());
}
export function applyLayoutConfiguration(configurationModel, configuration) {
    applyConfigurationModelSimple(configurationModel, LAYOUT_ALGORITHM_CONFIGURATION_IRI, configuration);
}
export const LAYOUT_ALGORITHM_CONFIGURATION_IRI = "http://dataspecer.com/resources/local/layout-configuration";
//# sourceMappingURL=layout-configuration-model.js.map